{
  "de": {
    "validations": {
      "required": "Das Feld %{field} ist erforderlich",
      "min": "Das Feld %{field} muss mindestens %{min} Zeichen haben",
      "max": "Das Feld %{field} darf höchstens %{max} Zeichen haben",
      "alpha_dash": "The %{field} field may contain alpha-numeric characters as well as dashes and underscores",
      "email": "Das Feld %{field} muss eine gültige E-Mail-Adresse sein",
      "confirmed": "Das Feld %{field} stimmt nicht überein",
      "numeric": "Das Feld %{field} darf nur numerische Zeichen enthalten",
      "between": "Das Feld %{field} muss zwischen %{min} und %{max} liegen",
      "min_value": "Das Feld %{field} muss %{min} oder mehr betragen",
      "url": "Das Feld %{field} ist keine gültige URL"
    }
  }
}
